import React, { Component } from 'react';
import autobind from 'react-autobind';
import PropTypes from 'prop-types';
import { Page } from './Page';

export const ITEMS_PER_PAGE = 12;

export default class Pagination extends Component {

  constructor(props) {
    super(props);
    autobind(this);
  }

  render() {
    const { currentPage, itemsCount, onClick } = this.props

    let pageCount = 0
    const pageButtons = []
    if (itemsCount) {
      for (let i = 0; i < itemsCount; i += ITEMS_PER_PAGE) {
        const isCurrent = currentPage === pageCount
        pageCount += 1
        pageButtons.push(
          <Page key={`page-btn-${i}`} onClick={onClick} pageCount={pageCount} isCurrent={isCurrent} />
        )
      }

      return (
        <div className="d-flex justify-content-between align-items-center">
          <p className="mb-0">
            {`Showing ${currentPage * ITEMS_PER_PAGE + 1} to 
            ${Math.min((currentPage + 1) * ITEMS_PER_PAGE, itemsCount)} 
            of ${itemsCount} entries`}
          </p>
          <ul className="pagination">
            {currentPage !== 0 && <Page onClick={onClick} pageCount={currentPage} text="Prev" />}
            {pageButtons}
            {itemsCount > ITEMS_PER_PAGE && currentPage < Math.floor(itemsCount / ITEMS_PER_PAGE) && <Page onClick={onClick} pageCount={currentPage + 2} text="Next" />}
          </ul>
        </div>
      )
    }
    return null
  }

}

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  itemsCount: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js